import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { AuthorityQuery as AuthorityQueryType, AuthorityQueryVariables } from "./__generated__/AuthorityQuery";

const AuthorityQuery = loader("./AuthorityQuery.gql");

type AuthorityQueryProviderType = (props: {
  children: (data: AuthorityQueryType) => ReactNode;
  variables: AuthorityQueryVariables;
}) => ReactElement;

export const AuthorityQueryProvider: AuthorityQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<AuthorityQueryType, AuthorityQueryVariables>(AuthorityQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
